import React from "react";
import Spacer from "../Spacer";

export interface ComingSoonHeaderProps {
  header: string;
}

const ComingSoonHeader = ({ header }: ComingSoonHeaderProps) => {
  return (
    <Spacer>
      <div className="my-4 text-lg font-medium">Coming soon</div>
      <div className="max-w-xs my-4 text-6xl font-bold leading-none">
        {header}
      </div>
      <div className="my-4 text-xs text-gray-400">November 24-27, 2020</div>
      <div className="my-4">Please come back again soon.</div>
    </Spacer>
  );
};

export default ComingSoonHeader;
